<template>
  <div>
    <v-card outlined flat>
      <v-app-bar color="primary" short dense dark flat>
        <v-toolbar-title>Riwayat Gaji Berkala</v-toolbar-title>
        <v-spacer></v-spacer>

        <div class="mr-3 mt-1">
          <rwgajiModalAdd />
        </div>

        <div style="max-width: 300px">
          <v-tabs v-model="tab" right dark background-color="primary">
            <v-tab href="#tab-1" @click="getSIMASN()">
              <h5>IDASN</h5>
            </v-tab>
          </v-tabs>
        </div>
      </v-app-bar>

      <v-tabs-items v-model="tab" touchless>
        <v-tab-item value="tab-1" class="pa-5">
          <rwgajiSIMASN />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import getData from '@/store/asn/rwgaji/tabs'
import rwgajiSIMASN from '@/components/asn/profil/rwgaji/rwgaji'
import rwgajiModalAdd from '@/components/asn/profil/rwgaji/ModalAdd'

export default {
  name: 'DataUtama',

  components: {
    rwgajiSIMASN,
    rwgajiModalAdd,
  },

  computed: {
    dataSAPK: {
      get() {
        return getData.state.tabSAPK
      },

      set(value) {
        getData.commit('getSAPK', value)
      },
    },
  },

  data: () => ({
    tab: null,
  }),

  methods: {
    getSAPK() {
      getData.commit('getSAPK', true)
      getData.commit('getSIMASN', false)
    },
    getSIMASN() {
      getData.commit('getSIMASN', true)
      getData.commit('getSAPK', false)
    },
  },
}
</script>
